import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import SimpleTable from "../components/SimpleTable";

export default function Inventory({receiverId, companyId, role}) {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const authUserString = sessionStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = receiverId || authUser?.id;
  const company_id = authUser?.company_id || companyId;

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}&company_id=${company_id}&per_page=${rowsPerPage}`
        );

        const data = res.data.data || [];

        const rows = data.map((item) => [
          item.key_type === 1 ? "Regular Key" : "Smart Key",
          item.package_name,
          // item.qty,
          // item.total_assigned_qty,
          item.balance_keys,
        ]);

        setInventory(rows);
      } catch (err) {
        console.error("Failed to fetch inventory:", err);
        setError("Failed to load inventory data.");
      } finally {
        setLoading(false);
      }
    };

    fetchInventory();
  }, [loginUserID]);

  // Pagination helpers
  const totalPages = Math.ceil(inventory.length / rowsPerPage);
  const paginate = (array, page) =>
    array.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div className="space-y-3 sm:space-y-4">
      <Header title="Inventory" />

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && !error && (
        <>
          <SimpleTable
            headers={["Product", "Model/Package", "Available"]}
            rows={paginate(inventory, page)}
          />

          {/* Pagination controls */}
          <div className="flex justify-center gap-2 mt-2">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Prev
            </button>
            <span>{page} / {totalPages}</span>
            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import SimpleTable from "../components/SimpleTable";

// export default function Inventory() {
//   const [inventory, setInventory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Replace with dynamic loginUserID if needed
//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   console.log("senior id:", loginUserID);

//   useEffect(() => {
//     const fetchInventory = async () => {
//       try {
//         const res = await axios.get(
//           `https://goelectronix.in/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
//         );

//         const data = res.data.data || [];

//         // Transform response into rows for SimpleTable
//         const rows = data.map((item) => [
//           item.key_type === 1 ? "Regular Key" : "Smart Key", // Product
//           item.package_name,                                // Model/Package
//           item.qty,                                         // In Stock
//           item.total_assigned_qty,                          // Allocated
//           item.balance_keys,                                // Available
//         ]);

//         setInventory(rows);
//       } catch (err) {
//         console.error("Failed to fetch inventory:", err);
//         setError("Failed to load inventory data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInventory();
//   }, [loginUserID]);

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Inventory" />

//       {loading && <p>Loading...</p>}
//       {error && <p className="text-red-500">{error}</p>}

//       {!loading && !error && (
//         <SimpleTable
//           headers={[
//             "Product",
//             "Model/Package",
//             "In Stock",
//             "Allocated",
//             "Available",
//           ]}
//           rows={inventory}
//         />
//       )}
//     </div>
//   );
// }


// import Header from "../components/Header";
// import SimpleTable from "../components/SimpleTable";

// export default function Inventory() {
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Inventory" />
//       <SimpleTable
//         headers={["Product", "Model/Package", "In Stock", "Allocated", "Available"]}
//         rows={[["Regular Key", "Regular + Warranty", "180", "120", "60"], ["Smart Key", "Smart Key", "170", "130", "40"]]}
//       />
//     </div>
//   );
// }